import validate from 'validate.js';

const constraints = {
    title: {
	presence: { 
	    message: 'napiši naslov'
	}
    },
    description: {
	presence: { 
	    message: 'napiši opis'
	}
    }
}

const PodcastValidator = ( fields ) => {
    var validations= validate(fields, constraints, {fullMessages: false}) || {};
 
    return validations
}

export default PodcastValidator ;



// WEBPACK FOOTER //
// ./src/validators/PodcastValidator.js